export default "__VITE_ASSET__BD6ddiTk__"